import { ArrowGreenDownSmall, ArrowRedUpSmall, TAG_STATUS } from '@evinced-private/ui-common';

import { STATUS_MAPPING, TREND_MAPPING } from '../constants';
import { AccessibilityStatus, StatusTag, TrendDirection, TrendTag } from '../types';

import { AccessibilityMetric } from './accessibilityHelpers';

export const getStatusTag = (status: AccessibilityStatus): StatusTag => STATUS_MAPPING[status];

export const getNAStatusTag = (): StatusTag => ({
	status: TAG_STATUS.INFO,
	text: 'N/A'
});

const formatNumber = (value: number): string => {
	return new Intl.NumberFormat('en-US').format(value);
};

export const getTrendTag = (metric: AccessibilityMetric): TrendTag => {
	// Handle N/A case
	if (metric.value === '0') {
		return {
			status: TAG_STATUS.INFO,
			text: 'N/A'
		};
	}
	if (metric.trend.percentage === 0) {
		return {
			status: TAG_STATUS.INFO,
			text: '+0%'
		};
	}
	const isPositive = metric.trend.direction === TrendDirection.UP;
	// For accessibility issues: UP (more issues) = bad = red arrow, DOWN (fewer issues) = good = green arrow
	// Match colors to sentiment: red for bad trends, green for good trends
	const icon = isPositive ? ArrowRedUpSmall : ArrowGreenDownSmall;
	const status = TREND_MAPPING[metric.trend.direction];
	const formattedPercentage = formatNumber(metric.trend.percentage);
	const text = `${isPositive ? '+' : '-'}${formattedPercentage}%`;

	return { icon, status, text };
};

export const getTrendAriaLabel = (metric: AccessibilityMetric): string => {
	if (metric.value === '0') {
		return 'No data available';
	}
	return `Trend: ${metric.trend.direction} by ${formatNumber(metric.trend.percentage)}%`;
};
